import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./access-list.component.html?ngResource";
import { Component, Inject, ViewEncapsulation, inject } from '@angular/core';
import { SplitterModule } from 'primeng/splitter';
import { ListComponent } from '../../components/list/list.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { InplaceModule } from 'primeng/inplace';
import { CheckboxModule } from 'primeng/checkbox';
import { BadgeModule } from 'primeng/badge';
import { TreeModule } from 'primeng/tree';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { AccessUsersGridComponent } from './access-users-grid/access-users-grid.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import EquipmentInfoService from '../../../components/base/infoServices/EquipmentInfoService';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { EquipmentAssignmentListComponent } from './equipment-assignment-list/equipment-assignment-list';
import { OrganizationsComponent } from '../../components/organizations/organizations.component';
import { AccessListService } from './services/access-list.service';
import { Subject, catchError, takeUntil, tap, throwError } from 'rxjs';
import { OrganizationService } from '../../shared/services/organization.service';
import { DropdownModule } from 'primeng/dropdown';
import { ScheduleSelectorComponent } from '../../modules/scheduling/components/schedule-selector/schedule-selector.component';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDestructiveDialogComponent } from '../../components/confirm-destructive-dialog/confirm-destructive-dialog.component';
let AccessListComponent = class AccessListComponent {
    document;
    accessListService = inject(AccessListService);
    organizationService = inject(OrganizationService);
    equipmentInfoService = inject(EquipmentInfoService);
    messageService = inject(MessageService);
    confirmationService = inject(ConfirmationService);
    fb = inject(FormBuilder);
    unsubscribe$ = new Subject();
    checked = [];
    items;
    lists = [];
    organizations = this.organizationService.model;
    selectedList;
    sourceEq = [];
    targetEq = [];
    originalLists = [];
    eq;
    allEq;
    originalSourceEq;
    originalTargetEq;
    accessListForm;
    accessListDialog;
    loadingTree;
    schedules = [];
    showDelete;
    showDeleteConfirmDialog;
    initialEquipmentLoadPromise;
    constructor(document) {
        this.document = document;
    }
    async ngOnInit() {
        this.loadingTree = true;
        this.showDelete = [
            'partner',
            'superAdmin',
        ].includes(window.appConfig.user.kind); // TODO
        this.organizationService
            .getOrganizations()
            .pipe(takeUntil(this.unsubscribe$), tap((data) => {
            this.organizations = data;
        }))
            .subscribe();
        // Save the promise to load equipment data
        this.initialEquipmentLoadPromise = this.fetchEquipmentData();
        this.fetchListsData().subscribe(() => {
            this.createForm();
            this.selectNodeFromUrl();
        });
    }
    selectNodeFromUrl() {
        const urlParams = new URLSearchParams(this.document.location.search);
        const listId = urlParams.get('listId');
        if (listId) {
            const node = this.findNodeById(this.lists, listId);
            if (node) {
                this.expandNodePath(node);
                this.selectionChanged({ node });
            }
        }
    }
    findNodeById(nodes, id) {
        for (const node of nodes) {
            if (node.data === id) {
                return node;
            }
            if (node.children) {
                const foundNode = this.findNodeById(node.children, id);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
        return undefined;
    }
    async fetchEquipmentData() {
        try {
            const equipment = await this.equipmentInfoService.getEquipmentByType(['gates', 'accessControls']);
            this.allEq = equipment;
        }
        catch (error) {
            console.error('Error loading data', error);
        }
    }
    fetchListsData() {
        return this.accessListService.getAccessLists().pipe(takeUntil(this.unsubscribe$), tap((model) => {
            this.originalLists = model.array;
            this.lists = this.convertToTreeStructure(model.array);
            this.loadingTree = false;
        }), catchError((error) => {
            console.error(error);
            return throwError(() => new Error('Error fetching lists data'));
        }));
    }
    get hasClassName() {
        return (this.sourceEq.some((item) => item.className && item.className !== '') ||
            this.targetEq.some((item) => item.className && item.className !== ''));
    }
    get formC() {
        return this.accessListForm.controls;
    }
    createForm() {
        this.accessListForm = this.fb.group({
            name: ['', [Validators.required]],
            org: ['', [Validators.required]],
            id: [''],
            schedules: [[], { nonNullable: true }],
            exclusionSchedules: [[], { nonNullable: true }],
        });
    }
    async selectionChanged($event) {
        const { node } = $event;
        if (node.type === 'org') {
            node.expanded = !node.expanded;
            return;
        }
        const newList = this.originalLists.find((list) => list.id === node.data);
        if (newList) {
            this.selectedList = { ...newList };
            if (!this.allEq) {
                await this.initialEquipmentLoadPromise;
            }
            this.eq = this.allEq?.filter((eq) => eq.org === newList.org);
            this.sourceEq = [
                ...this.eq.filter(eqItem => !this.selectedList.equipment.some((selectedEq) => selectedEq.id === eqItem.id)),
            ];
            this.targetEq = [...this.selectedList.equipment];
            this.originalSourceEq = [...this.sourceEq];
            this.originalTargetEq = [...this.targetEq];
            const url = new URL(this.document.location.toString());
            url.searchParams.set('listId', newList.id);
            window.history.replaceState({}, '', url.toString());
        }
    }
    expandRecursive(node, isExpand) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach(child => this.expandRecursive(child, isExpand));
        }
    }
    expandNodePath(node) {
        let currentNode = node;
        while (currentNode) {
            currentNode.expanded = true;
            currentNode = currentNode.parent;
        }
    }
    createTreeNode(item, overrides = {}) {
        return {
            label: item.name,
            icon: item.equipmentType === 'accessControls' ? 'fa fa-door-open' : 'pi pi-cog',
            data: item.id,
            key: item.id,
            type: 'equipment',
            ...overrides,
        };
    }
    convertToTreeStructure(inputData) {
        const orgGroups = inputData.reduce((acc, accessList) => {
            const orgId = accessList.org;
            if (!acc[orgId]) {
                const orgName = this.organizations.byId[orgId]?.name || 'Unknown Organization';
                acc[orgId] = { id: orgId, name: orgName, accessLists: [] };
            }
            acc[orgId].accessLists.push({
                ...accessList,
                equipment: accessList.equipment || [],
            });
            return acc;
        }, {});
        // Helper to set .parent recursively
        function setParent(child, parent) {
            if (child && typeof child === 'object') {
                child.parent = parent;
            }
        }
        const orgNodes = Object.values(orgGroups)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((orgGroup) => {
            const orgNode = {
                label: orgGroup.name,
                data: orgGroup.name,
                key: orgGroup.id,
                type: 'org',
                icon: 'pi pi-building',
                children: [],
            };
            orgNode.children = orgGroup.accessLists
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((accessItem) => {
                const accessListNode = {
                    label: accessItem.name,
                    data: accessItem.id,
                    key: accessItem.id,
                    type: 'accessList',
                    icon: 'pi pi-list',
                    children: [],
                };
                accessListNode.children = accessItem.equipment
                    ? accessItem.equipment
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((equip) => {
                        const equipNode = this.createTreeNode(equip, { data: accessItem.id });
                        setParent(equipNode, accessListNode);
                        return equipNode;
                    })
                    : [];
                // Set parent for accessListNode's children
                accessListNode.children.forEach(child => setParent(child, accessListNode));
                setParent(accessListNode, orgNode);
                return accessListNode;
            });
            // Set parent for orgNode's children
            orgNode.children.forEach(child => setParent(child, orgNode));
            // orgNode.parent is undefined (root)
            return orgNode;
        });
        return orgNodes.filter(Boolean);
    }
    expandAll() {
        this.lists.forEach((node) => {
            this.expandRecursive(node, true);
        });
    }
    collapseAll() {
        this.lists.forEach((node) => {
            this.expandRecursive(node, false);
        });
    }
    saveAccessListEquipment() {
        this.confirmationService.confirm({
            message: `Saving will synchronize '${this.selectedList.name}' users into the selected devices,
          and remove them from the removed devices. Do you want to proceed?`,
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: 'Synchronize',
            acceptButtonStyleClass: 'p-button-primary',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.accessListService
                    .saveGates(this.selectedList.id, this.targetEq.map(equipment => equipment.id))
                    .pipe(takeUntil(this.unsubscribe$), tap(() => {
                    // Force refresh
                    this.fetchListsData().subscribe({
                        next: () => {
                            // Programmatically select the newly created list
                            const selectedId = this.selectedList.id;
                            this.selectedList = null;
                            this.selectionChanged({ node: { data: selectedId } });
                        },
                        complete: () => {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Successful',
                                detail: 'User list synchronized with equipment.',
                                life: 3000,
                            });
                        }
                    });
                }), tap({
                    error: (error) => {
                        console.error('Failed to synchronize user list with equipment:', error);
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'There was an error while trying to synchronize the ' +
                                'user list with the equipment. Please try again.',
                            life: 3000,
                        });
                    },
                }))
                    .subscribe();
            },
        });
    }
    discardChanges() {
        this.sourceEq = this.originalSourceEq.map(item => ({ ...item, className: '' }));
        this.targetEq = this.originalTargetEq.map(item => ({ ...item, className: '' }));
    }
    openNew() {
        this.accessListForm.reset();
        this.accessListDialog = true;
    }
    hideDialog() {
        this.accessListDialog = false;
        this.accessListForm.reset();
    }
    saveAccessList() {
        if (this.accessListForm.valid) {
            if (this.accessListForm.value.id) {
                this.accessListService
                    .updateList(this.accessListForm.value.id, this.accessListForm.value)
                    .pipe(takeUntil(this.unsubscribe$), tap((updated) => {
                    this.hideDialog();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'List Updated',
                        life: 3000,
                    });
                    this.selectedList = updated;
                    this.fetchListsData().subscribe();
                }), catchError(() => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred', life: 3000 });
                    return throwError(() => new Error('An error occurred'));
                }))
                    .subscribe();
            }
            else {
                this.accessListService
                    .createList(this.accessListForm.value)
                    .pipe(takeUntil(this.unsubscribe$), tap((created) => {
                    this.hideDialog();
                    this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'List Added', life: 3000 });
                    this.fetchListsData().subscribe({
                        next: () => {
                            this.selectedList = null;
                            this.selectionChanged({ node: { data: created.id } });
                        }
                    });
                }), catchError((error) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
                    return throwError(() => error);
                }))
                    .subscribe();
            }
            this.accessListDialog = false;
        }
    }
    trackByFn(_index, item) {
        return item.key;
    }
    editAccessList() {
        this.accessListForm.patchValue(this.selectedList);
        this.accessListDialog = true;
    }
    deleteAccessList() {
        this.accessListService
            .removeList(this.selectedList.id)
            .pipe(takeUntil(this.unsubscribe$), tap(() => {
            // Force refresh
            this.fetchListsData().subscribe({
                next: () => {
                    this.selectedList = null;
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Access List deleted.',
                        life: 3000,
                    });
                },
                complete: () => {
                    this.showDeleteConfirmDialog = false;
                }
            });
        }), tap({
            error: (_error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Could not delete access list. Please try again.',
                    life: 3000,
                });
            },
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    static ctorParameters = () => [
        { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ];
};
AccessListComponent = __decorate([
    Component({
        selector: 'access-list',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        encapsulation: ViewEncapsulation.None,
        providers: [ConfirmationService, MessageService, AccessListService],
        imports: [
            SplitterModule,
            ListComponent,
            CommonModule,
            InplaceModule,
            TreeModule,
            CheckboxModule,
            BadgeModule,
            SelectButtonModule,
            FormsModule,
            ContextMenuModule,
            AccessUsersGridComponent,
            InputSwitchModule,
            DividerModule,
            InputTextModule,
            ButtonModule,
            ConfirmPopupModule,
            ConfirmDialogModule,
            DialogModule,
            ToastModule,
            EquipmentAssignmentListComponent,
            ReactiveFormsModule,
            DialogModule,
            OrganizationsComponent,
            DropdownModule,
            ScheduleSelectorComponent,
            CheckboxModule,
            TooltipModule,
            ConfirmDestructiveDialogComponent,
            TooltipModule
        ],
    })
], AccessListComponent);
export { AccessListComponent };
